import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSpecies } from "../../../../enums/queryFunction/Delete";
import React from "react";
import { SnackbarContext } from "../../../../contexts/Snackbar";

export default function useDelete(id, key) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const deleteFunc = async (id) => {
    setLoading(true);
    mutate(id);
  };

  function removeFromList() {
    queryClient.setQueryData([key], (oldData) => {
      if (!oldData) return oldData;
      return oldData.filter((item) => Number(item.id) !== Number(id));
    });
  }

  const { mutate } = useMutation({
    mutationFn: deleteSpecies,
    onSuccess: () => {
      removeFromList();
      setLoading(false);
      handleSnackbar("successMessage", "success");
    },
    onError: (error) => {
      setLoading(false);
      handleSnackbar(error?.response?.data, "error");
    },
  });

  return {
    loading,
    deleteFunc,
  };
}
